import { Box, Drawer, Grid, Paper, Typography } from '@mui/material'
import { useNavigate, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { BasePathProvider } from 'components/Providers'
import EnrollmentList from './List/List'
import EnrollmentFormIndex from './Form/index'
import { useEffect } from 'react'
import { mentorList } from 'store/mentorship/mentorship'

const basePath = '/mentorship/management/enrollment'

const StatCard = ({ label, value, color }) => (
  <Paper
    elevation={0}
    sx={{
      px: 2,
      pt: 2,
      pb: 2.5,
      borderRadius: 2,
      border: '1px solid',
      borderColor: 'divider',
      borderTop: `3px solid ${color}`,
      textAlign: 'center',
    }}
  >
    <Typography variant="h4" fontWeight={800} lineHeight={1} sx={{ color }}>
      {value}
    </Typography>
    <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 0.75 }}>
      {label}
    </Typography>
  </Paper>
)

export default function EnrollmentPage() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { id } = useParams()
  const list = useSelector(state => state.mentorship.mentorship.list)
  const mentors = useSelector(state => state.mentorship.mentorship.mentors)

  const total = list?.length ?? '—'
  const active = list?.filter(m => !m.endDate).length ?? '—'

  useEffect(() => {
    if (!mentors) {
      dispatch(mentorList({ permission: 'mentorship.mentor' }))
    }
  }, [mentors, dispatch])

  return (
    <BasePathProvider value={basePath}>
      <Box sx={{ p: 1 }}>
        <Grid container spacing={2} sx={{ mb: 3 }}>
          <Grid item xs={6} sm={3}>
            <StatCard label={t('Total Enrollments')} value={total} color="#1976d2" />
          </Grid>
          <Grid item xs={6} sm={3}>
            <StatCard label={t('Active')} value={active} color="#2e7d32" />
          </Grid>
        </Grid>

        <EnrollmentList />
      </Box>

      <Drawer
        PaperProps={{ sx: { width: { xs: '100%', sm: 480 } } }}
        open={Boolean(id)}
        anchor="right"
        onClose={() => navigate(basePath)}
      >
        <EnrollmentFormIndex />
      </Drawer>
    </BasePathProvider>
  )
}
